import {Vue, Component} from 'vue-property-decorator';
import List from '@/components/List';
import Navigation from '@/components/Navigation';
import OrderComponents from '@/components/OrderComponents';
import OrderCenterStore from '@/store/OrderCenterStore';
import Log from '@/components/Log';

import { Observer } from "mobx-vue";

@Observer
@Component
export default class Order  extends Vue {
  
  constructor(props: any) {
    super(props)
  }
  
  state = {
    OrderCenterStore
  }
  
  async mounted () {
    await this.state.OrderCenterStore.getOrderCenterList()
  }
  
  render() {
    return (
      <div class='order grey card'>
        <Navigation title='订单中心' />
        <Log type='hooks' number='N0700'/>
        <List
          style='background: #FAFAFA;'
          renderItem={(item: any, index: number) => <OrderComponents index={index} data={item} />}
          dataSource={this.state.OrderCenterStore.orderCenterList}
          empty={{description: '还没有订单记录'}} />
      </div>
    )
  }
  
}